import { render, staticRenderFns } from "./modal-view.vue?vue&type=template&id=6c20719b&scoped=true"
import script from "./modal-view.vue?vue&type=script&lang=js"
export * from "./modal-view.vue?vue&type=script&lang=js"
import style0 from "./modal-view.vue?vue&type=style&index=0&id=6c20719b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20719b",
  null
  
)

export default component.exports